import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
export const DefaultGltfLoader = new GLTFLoader();
export const DefaultAssetBasePath = 'https://cdn.jsdelivr.net/npm/@webxr-input-profiles/assets@1.0/dist/profiles/';
export { getXRControllerComponentObject, configureXRControllerModel, createUpdateXRControllerVisuals, loadXRControllerModel, } from './controller/index.js';
export { isXRInputSourceState, } from './input.js';
export * from './visible.js';
export * from './pointer/index.js';
export * from './vanilla/index.js';
export * from './misc.js';
export * from './teleport.js';
export * from './hit-test.js';
export * from './anchor.js';
export * from './layer.js';
export * from './controller-locomotion.js';
